import React, { Component } from 'react';
import {toast } from 'react-toastify';
import cookie from 'react-cookies';
import $ from 'jquery';
import {updateValueInJson, showModalPageClass, hideModalPageClass} from '../../../../../functions';
import axios from 'axios';
import {API_URL} from '../../../../../constants';
import ModalMultimedia from '../../../../Partials/ModalMultimedia';

export default class AdmPerfilador extends Component {

    constructor(props) {

        super(props); 

        this.state = { 
            modulo: this.props.modulo,
            titulo1Longitud:0,
            tituloBold1Longitud:0,
            extracto1Longitud:0,
            titulo2Longitud:0,
            tituloBold2Longitud:0,
            extracto2Longitud:0,
            titulo3Longitud:0,
            tituloBold3Longitud:0,
            extracto3Longitud:0,
            resource:{
                pmod_Id:0,
                pagi_Id:this.props.pagina,
                mweb_Id:this.props.modulo.id,
                mper_Titulo1:"",
                mper_TituloBold1:"",
                mper_Extracto1:"",
                mper_Icono1:"",
                mper_IconoActivo1:"",
                pweb_Id1:0,
                mper_Titulo2:"",
                mper_TituloBold2:"",
                mper_Extracto2:"",
                mper_Icono2:"",
                mper_IconoActivo2:"",
                pweb_Id2:0,
                mper_Titulo3:"",
                mper_TituloBold3:"",
                mper_Extracto3:"",
                mper_Icono3:"",
                mper_IconoActivo3:"",
                pweb_Id3:0,
                mper_Activo:false
            },
            resourceEdit:{
                mper_Id:0,
                mper_Titulo1:"",
                mper_TituloBold1:"",
                mper_Extracto1:"",
                mper_Icono1:"",
                mper_IconoActivo1:"",
                pweb_Id1:0,
                mper_Titulo2:"",
                mper_TituloBold2:"",
                mper_Extracto2:"",
                mper_Icono2:"",
                mper_IconoActivo2:"",
                pweb_Id2:0,
                mper_Titulo3:"",
                mper_TituloBold3:"",
                mper_Extracto3:"",
                mper_Icono3:"",
                mper_IconoActivo3:"",
                pweb_Id3:0,
                mper_Activo:false
            },
            Validacion: {
                mper_Titulo1: {
                    Error: false,                    
                },
                mper_TituloBold1: {
                    Error: false,                    
                },
                mper_Extracto1: {
                    Error: false,                    
                },
                mper_Icono1: {
                    Error: false,                    
                },
                mper_IconoActivo1: {
                    Error: false,                    
                },
                pweb_Id1: {
                    Error: false,                    
                },

                mper_Titulo2: {
                    Error: false,                    
                },
                mper_TituloBold2: {
                    Error: false,                    
                },
                mper_Extracto2: {
                    Error: false,                    
                },
                mper_Icono2: {
                    Error: false,                    
                },
                mper_IconoActivo2: {
                    Error: false,                    
                },
                pweb_Id2: {
                    Error: false,                    
                },

                mper_Titulo3: {
                    Error: false,                    
                },
                mper_TituloBold3: {
                    Error: false,                    
                },
                mper_Extracto3: {
                    Error: false,                    
                },
                mper_Icono3: {
                    Error: false,                    
                },
                mper_IconoActivo3: {
                    Error: false,                    
                },
                pweb_Id3: {
                    Error: false,                    
                }
            },
            ValidacionEdit:{
                mper_Titulo1: {
                    Error: false,                    
                },
                mper_TituloBold1: {
                    Error: false,                    
                },
                mper_Extracto1: {
                    Error: false,                    
                },
                mper_Icono1: {
                    Error: false,                    
                },
                mper_IconoActivo1: {
                    Error: false,                    
                },
                pweb_Id1: {
                    Error: false,                    
                },

                mper_Titulo2: {
                    Error: false,                    
                },
                mper_TituloBold2: {
                    Error: false,                    
                },
                mper_Extracto2: {
                    Error: false,                    
                },
                mper_Icono2: {
                    Error: false,                    
                },
                mper_IconoActivo2: {
                    Error: false,                    
                },
                pweb_Id2: {
                    Error: false,                    
                },

                mper_Titulo3: {
                    Error: false,                    
                },
                mper_TituloBold3: {
                    Error: false,                    
                },
                mper_Extracto3: {
                    Error: false,                    
                },
                mper_Icono3: {
                    Error: false,                    
                },
                mper_IconoActivo3: {
                    Error: false,                    
                },
                pweb_Id3: {
                    Error: false,                    
                }
                
            },
            perfiles: this.props.perfiles,
            hasError:false,
            added:false,
            confirmStore:false,
            security: cookie.load('user'),
            roles: [], 
            fieldReturnMultimedia:""
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeEdit = this.handleInputChangeEdit.bind(this);
        this.getResponseMultimedia = this.getResponseMultimedia.bind(this);
    }

    getResponseMultimedia = (urlSeleccionada) => {
        let resource = this.state.isEditfieldReturnMultimedia ? this.state.resourceEdit : this.state.resource;
        let fieldReturn = this.state.fieldReturnMultimedia;
    
        if(fieldReturn!== ""){
    
            resource[fieldReturn] = urlSeleccionada;
            
            if(this.state.isEditfieldReturnMultimedia){
                this.setState({resourceEdit:resource, fieldReturnMultimedia:"", isEditfieldReturnMultimedia:false});
            }else{
                this.setState({resource:resource, fieldReturnMultimedia:""});
            }
        }
    
        hideModalPageClass("divGestorArchivosPerfilador");
    }
    
    showModalMultimedia = (clase = "", campo = "", isEdition = false) => {
        this.setState({fieldReturnMultimedia:campo, isEditfieldReturnMultimedia:isEdition});
        showModalPageClass(clase);
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let titulo1Longitud = this.state.titulo1Longitud;
        let tituloBold1Longitud = this.state.tituloBold1Longitud;
        let extracto1Longitud = this.state.extracto1Longitud;

        let titulo2Longitud = this.state.titulo2Longitud;
        let tituloBold2Longitud = this.state.tituloBold2Longitud;
        let extracto2Longitud = this.state.extracto2Longitud;

        let titulo3Longitud = this.state.titulo3Longitud;
        let tituloBold3Longitud = this.state.tituloBold3Longitud;
        let extracto3Longitud = this.state.extracto3Longitud;

        let validaciones = this.state.Validacion;

        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'mper_Titulo1'){
            titulo1Longitud = value.length;
        }
        if(target.name == 'mper_TituloBold1'){
            tituloBold1Longitud = value.length;
        }
        if(target.name == 'mper_Extracto1'){
            extracto1Longitud = value.length;
        }

        if(target.name == 'mper_Titulo2'){
            titulo2Longitud = value.length;
        }
        if(target.name == 'mper_TituloBold2'){
            tituloBold2Longitud = value.length;
        }
        if(target.name == 'mper_Extracto2'){
            extracto2Longitud = value.length;
        }

        if(target.name == 'mper_Titulo3'){
            titulo3Longitud = value.length;
        }
        if(target.name == 'mper_TituloBold3'){
            tituloBold3Longitud = value.length;
        }
        if(target.name == 'mper_Extracto3'){
            extracto3Longitud = value.length;
        }

        this.setState({
            resource: copyResource,
            titulo1Longitud: titulo1Longitud,
            tituloBold1Longitud: tituloBold1Longitud,
            extracto1Longitud: extracto1Longitud,
            titulo2Longitud: titulo2Longitud,
            tituloBold2Longitud: tituloBold2Longitud,
            extracto2Longitud: extracto2Longitud,
            titulo3Longitud: titulo3Longitud,
            tituloBold3Longitud: tituloBold3Longitud,
            extracto3Longitud: extracto3Longitud,
            Validacion: validaciones
        });  
    }

    handleInputChangeEdit(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resourceEdit;
        copyResource[target.name] = value;

        let titulo1Longitud = this.state.titulo1Longitud;
        let tituloBold1Longitud = this.state.tituloBold1Longitud;
        let extracto1Longitud = this.state.extracto1Longitud;

        let titulo2Longitud = this.state.titulo2Longitud;
        let tituloBold2Longitud = this.state.tituloBold2Longitud;
        let extracto2Longitud = this.state.extracto2Longitud;

        let titulo3Longitud = this.state.titulo3Longitud;
        let tituloBold3Longitud = this.state.tituloBold3Longitud;
        let extracto3Longitud = this.state.extracto3Longitud;

        let validaciones = this.state.ValidacionEdit;

        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'mper_Titulo1'){
            titulo1Longitud = value.length;
        }
        if(target.name == 'mper_TituloBold1'){
            tituloBold1Longitud = value.length;
        }
        if(target.name == 'mper_Extracto1'){
            extracto1Longitud = value.length;
        }

        if(target.name == 'mper_Titulo2'){
            titulo2Longitud = value.length;
        }
        if(target.name == 'mper_TituloBold2'){
            tituloBold2Longitud = value.length;
        }
        if(target.name == 'mper_Extracto2'){
            extracto2Longitud = value.length;
        }

        if(target.name == 'mper_Titulo3'){
            titulo3Longitud = value.length;
        }
        if(target.name == 'mper_TituloBold3'){
            tituloBold3Longitud = value.length;
        }
        if(target.name == 'mper_Extracto3'){
            extracto3Longitud = value.length;
        }
        this.setState({
            resourceEdit: copyResource,
            titulo1Longitud: titulo1Longitud,
            tituloBold1Longitud: tituloBold1Longitud,
            extracto1Longitud: extracto1Longitud,
            titulo2Longitud: titulo2Longitud,
            tituloBold2Longitud: tituloBold2Longitud,
            extracto2Longitud: extracto2Longitud,
            titulo3Longitud: titulo3Longitud,
            tituloBold3Longitud: tituloBold3Longitud,
            extracto3Longitud: extracto3Longitud,
            ValidacionEdit: validaciones
        });  
    }

    storePerfilador = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.mper_Titulo1 == '') {              
            newState.Validacion.mper_Titulo1 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mper_TituloBold1 == '') {  
            newState.Validacion.mper_TituloBold1 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mper_Extracto1 == '') {              
            newState.Validacion.mper_Extracto1 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mper_Icono1 == '') {  
            newState.Validacion.mper_Icono1 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mper_IconoActivo1 == '') {  
            newState.Validacion.mper_IconoActivo1 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.pweb_Id1 == 0) {  
            newState.Validacion.pweb_Id1 = {Error: true};
            newState.hasError = true;
        }

        if (newState.resource.mper_Titulo2 == '') {              
            newState.Validacion.mper_Titulo2 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mper_TituloBold2 == '') {  
            newState.Validacion.mper_TituloBold2 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mper_Extracto2 == '') {              
            newState.Validacion.mper_Extracto2 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mper_Icono2 == '') {  
            newState.Validacion.mper_Icono2 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mper_IconoActivo2 == '') {  
            newState.Validacion.mper_IconoActivo2 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.pweb_Id2 == 0) {  
            newState.Validacion.pweb_Id2 = {Error: true};
            newState.hasError = true;
        }

        if (newState.resource.mper_Titulo3 == '') {              
            newState.Validacion.mper_Titulo3 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mper_TituloBold3 == '') {  
            newState.Validacion.mper_TituloBold3 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mper_Extracto3 == '') {              
            newState.Validacion.mper_Extracto3 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mper_Icono3 == '') {  
            newState.Validacion.mper_Icono3 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mper_IconoActivo3 == '') {  
            newState.Validacion.mper_IconoActivo3 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.pweb_Id3 == 0) {  
            newState.Validacion.pweb_Id3 = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloPerfiladorUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'mper_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                let result = data.data.result;
                let stateResponse = this.state;

                stateResponse.added = true;

                stateResponse.resource.mper_Titulo1 = '';
                stateResponse.resource.mper_TituloBold1 = '';
                stateResponse.resource.mper_Extracto1 = '';
                stateResponse.resource.mper_Icono1 = '';
                stateResponse.resource.mper_IconoActivo1 = '';
                stateResponse.resource.pweb_Id1 = 0;

                stateResponse.resource.mper_Titulo2 = '';
                stateResponse.resource.mper_TituloBold2 = '';
                stateResponse.resource.mper_Extracto2 = '';
                stateResponse.resource.mper_Icono2 = '';
                stateResponse.resource.mper_IconoActivo2 = '';
                stateResponse.resource.pweb_Id2 = 0;

                stateResponse.resource.mper_Titulo3 = '';
                stateResponse.resource.mper_TituloBold3 = '';
                stateResponse.resource.mper_Extracto3 = '';
                stateResponse.resource.mper_Icono3 = '';
                stateResponse.resource.mper_IconoActivo3 = '';
                stateResponse.resource.pweb_Id3 = 0;

                stateResponse.resource.pmod_Id = result.pmod_Id;

                document.getElementById("pweb_Id1").selectedIndex = 0;
                document.getElementById("pweb_Id2").selectedIndex = 0;
                document.getElementById("pweb_Id3").selectedIndex = 0;

                this.setState(stateResponse);

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 

                this.props.callback(true);

                $(".divClosePopup_Modals").trigger("click");

            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    updatePerfilador = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resourceEdit.mper_Titulo1 == '') {              
            newState.ValidacionEdit.mper_Titulo1 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mper_TituloBold1 == '') {  
            newState.ValidacionEdit.mper_TituloBold1 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mper_Extracto1 == '') {              
            newState.ValidacionEdit.mper_Extracto1 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mper_Icono1 == '') {  
            newState.ValidacionEdit.mper_Icono1 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mper_IconoActivo1 == '') {  
            newState.ValidacionEdit.mper_IconoActivo1 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.pweb_Id1 == 0) {  
            newState.ValidacionEdit.pweb_Id1 = {Error: true};
            newState.hasError = true;
        }
        
        if (newState.resourceEdit.mper_Titulo2 == '') {              
            newState.ValidacionEdit.mper_Titulo2 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mper_TituloBold2 == '') {  
            newState.ValidacionEdit.mper_TituloBold2 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mper_Extracto2 == '') {              
            newState.ValidacionEdit.mper_Extracto2 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mper_Icono2 == '') {  
            newState.ValidacionEdit.mper_Icono2 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mper_IconoActivo2 == '') {  
            newState.ValidacionEdit.mper_IconoActivo2 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.pweb_Id2 == 0) {  
            newState.ValidacionEdit.pweb_Id2 = {Error: true};
            newState.hasError = true;
        }
        
        if (newState.resourceEdit.mper_Titulo3 == '') {              
            newState.ValidacionEdit.mper_Titulo3 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mper_TituloBold3 == '') {  
            newState.ValidacionEdit.mper_TituloBold3 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mper_Extracto3 == '') {              
            newState.ValidacionEdit.mper_Extracto3 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mper_Icono3 == '') {  
            newState.ValidacionEdit.mper_Icono3 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mper_IconoActivo3 == '') {  
            newState.ValidacionEdit.mper_IconoActivo3 = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.pweb_Id3 == 0) {  
            newState.ValidacionEdit.pweb_Id3 = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloPerfiladorUX/`;
        var dataForm = this.state.resourceEdit;
        dataForm = updateValueInJson(dataForm,'mper_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                this.setState({added:true});

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    closePerfilador = () => {
        let resource = this.state.resource;
        resource.pmod_Id = 0;

        let resourceEdit = this.state.resourceEdit;
        resourceEdit.mper_Id = 0;
        this.setState({resource:resource, resourceEdit:resourceEdit});
        
        this.props.callback(true);
        
    }

    loadPerfilador = (pmod_Id) => 
    {
        const url = `${API_URL}ModuloPerfiladorUX/Seleccionar/${pmod_Id}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            
            this.setState({ resourceEdit: data.result, response: data, error: data.Error });           

        })
        .catch(error => {
            console.log("¡Error al inicializar!");
        });
    }    
    
    componentWillReceiveProps(nextProps){

        let mweb = 2;

        if(nextProps.pmodId !== this.state.resource.pmod_Id && mweb == nextProps.mWebEdit){
            let resource = this.state.resource;
            resource.pmod_Id = nextProps.pmodId;

            this.setState({resource: resource});

            setTimeout(() => { 
                this.loadPerfilador(resource.pmod_Id);
            }, 100); 
        }
      } 

    render() {

        let modulo = this.state.modulo;

        return (
            <div className="divModalBanner popUpGeneral" id={"modal_" + modulo.id} style={{display:"none"}}>
                <div className="divLayerPopup_ModalPaginas">
                    <div className="divPopup_ModalPaginas">
                    <div className="divClosePopup_Modals" onClick={() => this.closePerfilador()}/>
                    <h2>{modulo.nombre} </h2>
                    <div className="divWrapperModalPaginas">

                        {
                            this.state.resourceEdit.mper_Id > 0 ?
                            <React.Fragment>
                                <div className="containerFormCreation divModuloPopup_Panel">
                                {
                                    this.state.added ?
                                    <div className="txtFile x-1">
                                        <strong style={{
                                            display: "block",
                                            textAlign:"center",
                                            color: "#008000a3"
                                        }}> Registro actualizado satisfactoriamente!!</strong>
                                    </div> : null
                                }
                                

                                <div className="txtFile x-1">
                                    <input type="text" 
                                    placeholder="Título 1" 
                                    name='mper_Titulo1' 
                                    value={this.state.resourceEdit.mper_Titulo1} 
                                    maxLength={10} 
                                    className={this.state.ValidacionEdit.mper_Titulo1.Error ? "error" : ""}  
                                    onChange={this.handleInputChangeEdit}/>
                                    <span data-length={10}>{this.state.titulo1Longitud}/10</span>
                                </div>
                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Titulo negrita 1" 
                                    name='mper_TituloBold1' 
                                    value={this.state.resourceEdit.mper_TituloBold1} 
                                    className={this.state.ValidacionEdit.mper_TituloBold1.Error ? "error" : ""} 
                                    maxLength={30}  
                                    onChange={this.handleInputChangeEdit}/>
                                    <span data-length={30}>{this.state.tituloBold1Longitud}/30</span>
                                </div>
                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Resumen" 
                                    name='mper_Extracto1' 
                                    value={this.state.resourceEdit.mper_Extracto1} 
                                    className={this.state.ValidacionEdit.mper_Extracto1.Error ? "error" : ""} 
                                    maxLength={125}  
                                    onChange={this.handleInputChangeEdit}/>
                                    <span data-length={125}>{this.state.extracto1Longitud}/125</span>
                                </div>
                                <div className="txtFile x-1 relative">
                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosPerfilador", "mper_Icono1", true)}/>
                                    <input type="text" placeholder="Icono 1" 
                                    name='mper_Icono1' 
                                    value={this.state.resourceEdit.mper_Icono1} 
                                    className={this.state.ValidacionEdit.mper_Icono1.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
									<label class="recomendacion">Se recomienda la dimensión de 40px de ancho X 40px de alto.</label>
                                </div>
                                <div className="txtFile x-1 relative">
                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosPerfilador", "mper_IconoActivo1", true)}/>
                                    <input type="text" placeholder="Icono Activo 1" 
                                    name='mper_IconoActivo1' 
                                    value={this.state.resourceEdit.mper_IconoActivo1} 
                                    className={this.state.ValidacionEdit.mper_IconoActivo1.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
									<label class="recomendacion">Se recomienda la dimensión de 40px de ancho X 40px de alto.</label>
                                </div>
                                <div className="txtFile x-1">
                                    <select name='pweb_Id1' id='pweb_Id1' 
                                    onChange={this.handleInputChangeEdit}
                                    className={this.state.ValidacionEdit.pweb_Id1.Error ? "error" : ""} >
                                        <option value="0">Seleccionar Perfil 1</option>
                                        {
                                            this.state.perfiles.length > 0 ?
                                            this.state.perfiles.map((perfil) => (
                                                <option value={perfil.id} selected={(this.state.resourceEdit.pweb_Id1 == perfil.id) ? true : false}>{perfil.nombre.toUpperCase()}</option>
                                            ))
                                            : null
                                        }
                                    </select>                        
                                </div>

                                <br/>
                                <br/>

                                <div className="txtFile x-1">
                                    <input type="text" 
                                    placeholder="Título 2" 
                                    name='mper_Titulo2' 
                                    value={this.state.resourceEdit.mper_Titulo2} 
                                    maxLength={10} 
                                    className={this.state.ValidacionEdit.mper_Titulo2.Error ? "error" : ""}  
                                    onChange={this.handleInputChangeEdit}/>
                                    <span data-length={10}>{this.state.titulo2Longitud}/10</span>
                                </div>
                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Titulo negrita 2" 
                                    name='mper_TituloBold2' 
                                    value={this.state.resourceEdit.mper_TituloBold2} 
                                    className={this.state.ValidacionEdit.mper_TituloBold2.Error ? "error" : ""} 
                                    maxLength={30}  
                                    onChange={this.handleInputChangeEdit}/>
                                    <span data-length={30}>{this.state.tituloBold2Longitud}/30</span>
                                </div>
                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Resumen" 
                                    name='mper_Extracto2' 
                                    value={this.state.resourceEdit.mper_Extracto2} 
                                    className={this.state.ValidacionEdit.mper_Extracto2.Error ? "error" : ""} 
                                    maxLength={125}  
                                    onChange={this.handleInputChangeEdit}/>
                                    <span data-length={125}>{this.state.extracto2Longitud}/125</span>
                                </div>
                                <div className="txtFile x-1 relative">
                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosPerfilador", "mper_Icono2", true)}/>
                                    <input type="text" placeholder="Icono 2" 
                                    name='mper_Icono2' 
                                    value={this.state.resourceEdit.mper_Icono2} 
                                    className={this.state.ValidacionEdit.mper_Icono2.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
									<label class="recomendacion">Se recomienda la dimensión de 40px de ancho X 40px de alto.</label>
                                </div>
                                <div className="txtFile x-1 relative">
                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosPerfilador", "mper_IconoActivo2", true)}/>
                                    <input type="text" placeholder="Icono Activo 2" 
                                    name='mper_IconoActivo2' 
                                    value={this.state.resourceEdit.mper_IconoActivo2} 
                                    className={this.state.ValidacionEdit.mper_IconoActivo2.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
									<label class="recomendacion">Se recomienda la dimensión de 40px de ancho X 40px de alto.</label>
                                </div>
                                <div className="txtFile x-1">
                                    <select name='pweb_Id2' id='pweb_Id2' 
                                    onChange={this.handleInputChangeEdit}
                                    className={this.state.ValidacionEdit.pweb_Id2.Error ? "error" : ""} >
                                        <option value="0">Seleccionar Perfil 2</option>
                                        {
                                            this.state.perfiles.length > 0 ?
                                            this.state.perfiles.map((perfil) => (
                                                <option value={perfil.id} selected={(this.state.resourceEdit.pweb_Id2 == perfil.id) ? true : false}>{perfil.nombre.toUpperCase()}</option>
                                            ))
                                            : null
                                        }
                                    </select>                        
                                </div>

                                <br/>
                                <br/>

                                <div className="txtFile x-1">
                                    <input type="text" 
                                    placeholder="Título 3" 
                                    name='mper_Titulo3' 
                                    value={this.state.resourceEdit.mper_Titulo3} 
                                    maxLength={10} 
                                    className={this.state.ValidacionEdit.mper_Titulo3.Error ? "error" : ""}  
                                    onChange={this.handleInputChangeEdit}/>
                                    <span data-length={10}>{this.state.titulo3Longitud}/10</span>
                                </div>
                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Titulo negrita 3" 
                                    name='mper_TituloBold3' 
                                    value={this.state.resourceEdit.mper_TituloBold3} 
                                    className={this.state.ValidacionEdit.mper_TituloBold3.Error ? "error" : ""} 
                                    maxLength={30}  
                                    onChange={this.handleInputChangeEdit}/>
                                    <span data-length={30}>{this.state.tituloBold3Longitud}/30</span>
                                </div>
                                <div className="txtFile x-1">
                                    <input type="text" placeholder="Resumen" 
                                    name='mper_Extracto3' 
                                    value={this.state.resourceEdit.mper_Extracto3} 
                                    className={this.state.ValidacionEdit.mper_Extracto3.Error ? "error" : ""} 
                                    maxLength={125}  
                                    onChange={this.handleInputChangeEdit}/>
                                    <span data-length={125}>{this.state.extracto3Longitud}/125</span>
                                </div>
                                <div className="txtFile x-1 relative">
                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosPerfilador", "mper_Icono3", true)}/>
                                    <input type="text" placeholder="Icono 3" 
                                    name='mper_Icono3' 
                                    value={this.state.resourceEdit.mper_Icono3} 
                                    className={this.state.ValidacionEdit.mper_Icono3.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
									<label class="recomendacion">Se recomienda la dimensión de 40px de ancho X 40px de alto.</label>
                                </div>
                                <div className="txtFile x-1 relative">
                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosPerfilador", "mper_IconoActivo3", true)}/>
                                    <input type="text" placeholder="Icono Activo 3" 
                                    name='mper_IconoActivo3' 
                                    value={this.state.resourceEdit.mper_IconoActivo3} 
                                    className={this.state.ValidacionEdit.mper_IconoActivo3.Error ? "error" : ""} 
                                    onChange={this.handleInputChangeEdit}/>
									<label class="recomendacion">Se recomienda la dimensión de 40px de ancho X 40px de alto.</label>
                                </div>
                                <div className="txtFile x-1">
                                    <select name='pweb_Id3' id='pweb_Id3' 
                                    onChange={this.handleInputChangeEdit}
                                    className={this.state.ValidacionEdit.pweb_Id3.Error ? "error" : ""} >
                                        <option value="0">Seleccionar Perfil 3</option>
                                        {
                                            this.state.perfiles.length > 0 ?
                                            this.state.perfiles.map((perfil) => (
                                                <option value={perfil.id} selected={(this.state.resourceEdit.pweb_Id3 == perfil.id) ? true : false}>{perfil.nombre.toUpperCase()}</option>
                                            ))
                                            : null
                                        }
                                    </select>                        
                                </div>

        
                            </div>
                            <div>
                                <a href="" className="btnAgregarPagina noneEvent" id="btnActualizarPerfilador" onClick={(e) => this.updatePerfilador(e)}>ACTUALIZAR</a>
                                <br/>
                                <br/>
                                <br/>
                            </div>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <div className="containerFormCreation divModuloPopup_Panel">

                                    <div className="txtFile x-1">
                                        <input type="text" 
                                        placeholder="Título 1" 
                                        name='mper_Titulo1' 
                                        value={this.state.resource.mper_Titulo1} 
                                        maxLength={10} 
                                        className={this.state.Validacion.mper_Titulo1.Error ? "error" : ""}  
                                        onChange={this.handleInputChange}/>
                                        <span data-length={10}>{this.state.titulo1Longitud}/10</span>
                                    </div>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Titulo negrita 1" 
                                        name='mper_TituloBold1' 
                                        value={this.state.resource.mper_TituloBold1} 
                                        className={this.state.Validacion.mper_TituloBold1.Error ? "error" : ""} 
                                        maxLength={30}  
                                        onChange={this.handleInputChange}/>
                                        <span data-length={30}>{this.state.tituloBold1Longitud}/30</span>
                                    </div>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Resumen" 
                                        name='mper_Extracto1' 
                                        value={this.state.resource.mper_Extracto1} 
                                        className={this.state.Validacion.mper_Extracto1.Error ? "error" : ""} 
                                        maxLength={125}  
                                        onChange={this.handleInputChange}/>
                                        <span data-length={125}>{this.state.extracto1Longitud}/125</span>
                                    </div>
                                    <div className="txtFile x-1 relative">
                                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosPerfilador", "mper_Icono1")}/>
                                        <input type="text" placeholder="Icono 1" 
                                        name='mper_Icono1' 
                                        value={this.state.resource.mper_Icono1} 
                                        className={this.state.Validacion.mper_Icono1.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
										<label class="recomendacion">Se recomienda la dimensión de 40px de ancho X 40px de alto.</label>
                                    </div>
                                    <div className="txtFile x-1 relative">
                                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosPerfilador", "mper_IconoActivo1")}/>
                                        <input type="text" placeholder="Icono Activo 1" 
                                        name='mper_IconoActivo1' 
                                        value={this.state.resource.mper_IconoActivo1} 
                                        className={this.state.Validacion.mper_IconoActivo1.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
										<label class="recomendacion">Se recomienda la dimensión de 40px de ancho X 40px de alto.</label>
                                    </div>
                                    <div className="txtFile x-1">
                                        <select name='pweb_Id1' id='pweb_Id1' 
                                        onChange={this.handleInputChange}
                                        className={this.state.Validacion.pweb_Id1.Error ? "error" : ""} >
                                            <option value="0">Seleccionar Perfil 1</option>
                                            {
                                                this.state.perfiles.length > 0 ?
                                                this.state.perfiles.map((perfil) => (
                                                    <option value={perfil.id} key={perfil.id}>{perfil.nombre.toUpperCase()}</option>
                                                ))
                                                : null
                                            }
                                        </select>                        
                                    </div>

                                    <br/>
                                    <br/>

                                    <div className="txtFile x-1">
                                        <input type="text" 
                                        placeholder="Título 2" 
                                        name='mper_Titulo2' 
                                        value={this.state.resource.mper_Titulo2} 
                                        maxLength={10} 
                                        className={this.state.Validacion.mper_Titulo2.Error ? "error" : ""}  
                                        onChange={this.handleInputChange}/>
                                        <span data-length={10}>{this.state.titulo2Longitud}/10</span>
                                    </div>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Titulo negrita 2" 
                                        name='mper_TituloBold2' 
                                        value={this.state.resource.mper_TituloBold2} 
                                        className={this.state.Validacion.mper_TituloBold2.Error ? "error" : ""} 
                                        maxLength={30}  
                                        onChange={this.handleInputChange}/>
                                        <span data-length={30}>{this.state.tituloBold2Longitud}/30</span>
                                    </div>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Resumen" 
                                        name='mper_Extracto2' 
                                        value={this.state.resource.mper_Extracto2} 
                                        className={this.state.Validacion.mper_Extracto2.Error ? "error" : ""} 
                                        maxLength={125}  
                                        onChange={this.handleInputChange}/>
                                        <span data-length={125}>{this.state.extracto2Longitud}/125</span>
                                    </div>
                                    <div className="txtFile x-1 relative">
                                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosPerfilador", "mper_Icono2")}/>
                                        <input type="text" placeholder="Icono 2" 
                                        name='mper_Icono2' 
                                        value={this.state.resource.mper_Icono2} 
                                        className={this.state.Validacion.mper_Icono2.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
										<label class="recomendacion">Se recomienda la dimensión de 40px de ancho X 40px de alto.</label>
                                    </div>
                                    <div className="txtFile x-1 relative">
                                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosPerfilador", "mper_IconoActivo2")}/>
                                        <input type="text" placeholder="Icono Activo 2" 
                                        name='mper_IconoActivo2' 
                                        value={this.state.resource.mper_IconoActivo2} 
                                        className={this.state.Validacion.mper_IconoActivo2.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
										<label class="recomendacion">Se recomienda la dimensión de 40px de ancho X 40px de alto.</label>
                                    </div>
                                    <div className="txtFile x-1">
                                        <select name='pweb_Id2' id='pweb_Id2' 
                                        onChange={this.handleInputChange}
                                        className={this.state.Validacion.pweb_Id2.Error ? "error" : ""} >
                                            <option value="0">Seleccionar Perfil 2</option>
                                            {
                                                this.state.perfiles.length > 0 ?
                                                this.state.perfiles.map((perfil) => (
                                                    <option value={perfil.id} key={perfil.id}>{perfil.nombre.toUpperCase()}</option>
                                                ))
                                                : null
                                            }
                                        </select>                        
                                    </div>

                                    <br/>
                                    <br/>

                                    <div className="txtFile x-1">
                                        <input type="text" 
                                        placeholder="Título 3" 
                                        name='mper_Titulo3' 
                                        value={this.state.resource.mper_Titulo3} 
                                        maxLength={10} 
                                        className={this.state.Validacion.mper_Titulo3.Error ? "error" : ""}  
                                        onChange={this.handleInputChange}/>
                                        <span data-length={10}>{this.state.titulo3Longitud}/10</span>
                                    </div>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Titulo negrita 3" 
                                        name='mper_TituloBold3' 
                                        value={this.state.resource.mper_TituloBold3} 
                                        className={this.state.Validacion.mper_TituloBold3.Error ? "error" : ""} 
                                        maxLength={30}  
                                        onChange={this.handleInputChange}/>
                                        <span data-length={30}>{this.state.tituloBold3Longitud}/30</span>
                                    </div>
                                    <div className="txtFile x-1">
                                        <input type="text" placeholder="Resumen" 
                                        name='mper_Extracto3' 
                                        value={this.state.resource.mper_Extracto3} 
                                        className={this.state.Validacion.mper_Extracto3.Error ? "error" : ""} 
                                        maxLength={125}  
                                        onChange={this.handleInputChange}/>
                                        <span data-length={125}>{this.state.extracto3Longitud}/125</span>
                                    </div>
                                    <div className="txtFile x-1 relative">
                                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosPerfilador", "mper_Icono3")}/>
                                        <input type="text" placeholder="Icono 3" 
                                        name='mper_Icono3' 
                                        value={this.state.resource.mper_Icono3} 
                                        className={this.state.Validacion.mper_Icono3.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
										<label class="recomendacion">Se recomienda la dimensión de 40px de ancho X 40px de alto.</label>
                                    </div>
                                    <div className="txtFile x-1 relative">
                                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosPerfilador", "mper_IconoActivo3")}/>
                                        <input type="text" placeholder="Icono Activo 3" 
                                        name='mper_IconoActivo3' 
                                        value={this.state.resource.mper_IconoActivo3} 
                                        className={this.state.Validacion.mper_IconoActivo3.Error ? "error" : ""} 
                                        onChange={this.handleInputChange}/>
										<label class="recomendacion">Se recomienda la dimensión de 40px de ancho X 40px de alto.</label>
                                    </div>
                                    <div className="txtFile x-1">
                                        <select name='pweb_Id3' id='pweb_Id3' 
                                        onChange={this.handleInputChange}
                                        className={this.state.Validacion.pweb_Id3.Error ? "error" : ""} >
                                            <option value="0">Seleccionar Perfil 3</option>
                                            {
                                                this.state.perfiles.length > 0 ?
                                                this.state.perfiles.map((perfil) => (
                                                    <option value={perfil.id}>{perfil.nombre.toUpperCase()}</option>
                                                ))
                                                : null
                                            }
                                        </select>                        
                                    </div>


                                    </div>
                                    <div>
                                    <a href="" className="btnAgregarPagina noneEvent" id="btnGuardarPerfilador" onClick={(e) => this.storePerfilador(e)}>GUARDAR</a>
                                    <br/>
                                    <br/>
                                    <br/>
                                    </div>
                            </React.Fragment>
                        }
                        
                        

                    </div>
                    </div>
                </div>
                <ModalMultimedia class="divGestorArchivosPerfilador" callback={this.getResponseMultimedia.bind(this)}/>
            </div>
        )
    }
}
